export default __webpack_public_path__ + "static/media/energyIcon.bf4d6308.svg";